export default __webpack_public_path__ + "static/media/trash.a553f50e.svg";